import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';

const TerminosYCondicionesModal = ({ open, onClose }) => {
  const sections = [
    {
      title: "1. Rol de PassGo",
      content: `<p><em>PassGo</em> es una plataforma digital que facilita la compra de entradas para eventos organizados por terceros (en adelante, <em>"Organizadores"</em>). Actuamos únicamente como intermediarios tecnológicos entre el comprador (en adelante, <em>"Usuario"</em>) y el Organizador del evento. PassGo no es responsable de la organización, realización, postergación, suspensión o cancelación de los eventos.</p>`
    },
    {
      title: "2. Responsabilidad del Organizador",
      content: `<p>El <em>Organizador</em> es el único responsable por la realización del evento, la calidad del servicio ofrecido y el cumplimiento de toda la normativa vigente. Al adquirir una entrada, el Usuario acepta las condiciones impuestas por el Organizador, incluyendo su política de cambios, devoluciones, accesibilidad, programación y admisión.</p>`
    },
    {
      title: "3. Condiciones de la compra",
      content: `<p>Antes de finalizar la compra, el <em>Usuario</em> debe revisar cuidadosamente el evento, la fecha, ubicación, horario, sección y asiento seleccionado. Las compras son definitivas: no se permiten cambios, devoluciones ni
reintegros por error en la elección del evento o por imposibilidad de asistencia del Usuario.</p>`
    },
    {
      title: "4.  Cancelaciones, suspensiones o modificaciones",
      content: `<p>En caso de cancelación del evento, el <em>Organizador</em> dispondrá de hasta 90 días para efectuar la devolución del importe de las entradas. <em>PassGo</em> no realiza reembolsos directamente.
<br/>El <em>Organizador</em> se reserva el derecho a modificar fechas, horarios, programación, artistas, ubicación y condiciones generales del evento. También podrá ejercer su derecho de admisión según la normativa vigente.</p>`
    },

    {
      title: "5.  Validación de entradas",
      content: `<p>Las entradas son válidas únicamente si fueron adquiridas a través de <em>PassGo</em>. Cada entrada cuenta con un código QR único, que será escaneado al ingreso para evitar duplicaciones o fraudes. Es responsabilidad del <em>Usuario</em> presentar la entrada (impresa o desde su celular) junto con su DNI.</p>`
    },
    {
      title: "6.  Acceso al evento",
      content: `<p>El ingreso al evento puede estar sujeto a controles de seguridad. El personal podrá solicitar inspección de bolsos o pertenencias, y negar el acceso a quienes se nieguen a cumplir con las condiciones. El ingreso con cámaras, grabadoras o similares queda a criterio del <em>Organizador</em>.</p>`
    },
    {
      title: "7.  Medios de pago y confirmación",
      content: `<p>La compra se confirma únicamente tras la autorización del medio de pago correspondiente. En caso de rechazo por parte de la entidad emisora de la tarjeta, la compra no se considerará válida.</p>`
    },
    {
      title: "8.  Cargos por servicio",
      content: `<p>Toda entrada adquirida a través de <em>PassGo</em> puede incluir un cargo por servicio, claramente indicado al momento de la compra. Este monto corresponde a los costos operativos y de plataforma, y no es reembolsable bajo ninguna circunstancia.</p>`
    },
    {
      title: "9.  Protección de datos personales",
      content: `<p>Al utilizar <em>PassGo</em>, el <em>Usuario</em> acepta el tratamiento de sus datos personales según la Ley 25.326. Los datos podrán ser utilizados para brindar el servicio, así como para futuras comunicaciones comerciales, siempre con la posibilidad de ejercer los derechos de acceso, rectificación, actualización y supresión.
<br/>El <em>Usuario</em> podrá solicitar en cualquier momento el retiro o bloqueo de su información de las bases de datos enviando un correo a:  <a href="mailto:soporte@passgo.com.ar" style="color: #5656FF; text-decoration: none;">soporte@passgo.com.ar</a> <br/>
La Dirección Nacional de Protección de Datos Personales es el organismo encargado de atender denuncias y reclamos relacionados con el incumplimiento de esta normativa.</p>`
    },
    {
      title: "10.  Eventos Gratuitos",
      content: `<p>Los eventos gratuitos ofrecidos a través de <em>PassGo</em> también se encuentran sujetos a disponibilidad de cupo y confirmación de inscripción. Las entradas para estos eventos son personales e intransferibles, y su emisión no garantiza el ingreso si el <em>Usuario</em> no cumple con los requisitos establecidos por el <em>Organizador</em>(puntualidad, DNI, código QR válido, etc.).
<br/>Está prohibida la reventa o comercialización de entradas gratuitas. <em>PassGo</em> y el <em>Organizador</em> se reservan el derecho de modificar o cancelar el evento en cualquier momento, sin obligación de compensación económica al <em>Usuario</em>.</p>`
    },
    {
      title: "11.  Uso de imágenes y registro del evento",
      content: `<p>Al asistir a un evento para el cual se adquirieron entradas mediante <em>PassGo</em>, el <em>Usuario</em> acepta que el <em>Organizador</em> podrá realizar registros fotográficos, audiovisuales o transmisiones en vivo del evento. <br/>Estos materiales podrán ser utilizados con fines promocionales, informativos o comerciales. Al ingresar al evento, el <em>Usuario</em> autoriza el uso de su imagen en dichos registros sin que ello implique derecho a compensación alguna.</p>`
    },

  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
      PaperProps={{
        sx: {
          borderRadius: '10px',
          bgcolor: '#fff',
        }
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: '#0B0062',
          color: 'white',
          py: 2,
          fontSize: '20px',
          fontWeight: 600
        }}
      >
        TÉRMINOS Y CONDICIONES DE COMPRA - PASSGO
      </DialogTitle>

      <DialogContent sx={{ mt: 2, px: 4 }}>
        <Box sx={{ mb: 4 }}>
          {sections.map((section, index) => (
            <Box key={index} sx={{ mb: 3 }}>
              <Typography
                variant="h6"
                sx={{
                  color: '#0B0062',
                  fontWeight: 600,
                  mb: 1
                }}
              >
                {section.title}
              </Typography>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  color: '#333',
                  lineHeight: 1.4,
                  '& a:hover': {
                    textDecoration: 'underline !important'
                  }
                }}
                dangerouslySetInnerHTML={{ __html: section.content }}
              />
            </Box>
          ))}
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0' }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: '#5656FF',
            '&:hover': {
              backgroundColor: '#4545cc'
            },
            px: 4
          }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TerminosYCondicionesModal;